import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';

import { ICitizenMarker } from '@lib/cameras';
import { FsMapCitizenServiceProvider, IFsMap } from '@lib/geo/core';
import { SnCamera } from 'libs/api/entities/src/lib/camera';
import { SnCitizenVideoStream, SnCitizenIncidentDetails } from 'libs/api/entities/src/lib/citizen';

@Injectable()
export class MapCitizenFacadeService<TMap extends IFsMap> extends FsMapCitizenServiceProvider<TMap> {

  constructor(private readonly provider: FsMapCitizenServiceProvider<TMap>) {
    super();
  }

  get id(): string {
    return this.provider.id;
  }
  get geospatialProvider(): string {
    return this.provider.geospatialProvider;
  }
  get canChange(): boolean {
    return this.provider.canChange;
  }
  get isAvailable(): boolean {
    return this.provider.isAvailable;
  }
  get mapMarkers(): ICitizenMarker[] {
    return this.provider.mapMarkers;
  }
  get hovered$(): Observable<SnCitizenVideoStream> {
    return this.provider.hovered$;
  }
  get cameraSelected$(): Observable<SnCitizenVideoStream> {
    return this.provider.cameraSelected$;
  }

  onMapLoaded(map: TMap): void {
    return this.provider.onMapLoaded(map);
  }
  addToMap(): void {
    return this.provider.addToMap();
  }
  removeFromMap(): void {
    return this.provider.removeFromMap();
  }
  cameraHovered(camera: SnCitizenVideoStream): void {
    return this.provider.cameraHovered(camera);
  }
  openPopup(incident: SnCitizenIncidentDetails): void {
    return this.provider.openPopup(incident);
  }
  closePopup(): void {
    return this.provider.closePopup();
  }
  addPolyline(camera: SnCitizenVideoStream, element: Element): void {
    return this.provider.addPolyline(camera, element);
  }
  addPolylines(cameras: SnCamera[]): void {
    return this.provider.addPolylines(cameras);
  }
  removePolyline(): void {
    return this.provider.removePolyline();
  }
  removeLine(): void {
    return this.provider.removeLine();
  }
  clearPolylines(): void {
    return this.provider.clearPolylines();
  }
  point2LatLng(x: number, y: number): unknown {
    return this.provider.point2LatLng(x, y);
  }
}
